export default "__VITE_PUBLIC_ASSET__e8a4055e__"